import { TableCell, TableCellProps, Tooltip } from '@material-ui/core'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import React, { ReactElement } from 'react'
import InfoIcon from '@material-ui/icons/Info'

interface CornerTitlesCellProps extends TableCellProps {
  topTitle: string
  bottomTitle: string
  topTooltipText: string
  bottomTooltipText: string
}

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      position: 'relative',
      borderBottom: 'none',
      borderTopLeftRadius: 8,
      overflow: 'hidden',
    },
    topTriangleWrapper: {
      backgroundColor: '#E3EFF5',
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      '& $label': {
        textAlign: 'right',
      },
    },
    topTriangle: {
      height: '100%',
      marginLeft: '25%',
      shapeOutside: 'polygon(0 0 ,5% 0, 100% 85%, 100% 100%, 0 100%)',
      position: 'relative',
      display: 'flex',
      justifyContent: 'flex-end',
      padding: 16,
      alignItems: 'baseline',
    },
    bottomTriangleWrapper: {
      position: 'absolute',
      backgroundColor: '#EDF8F7',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      clipPath: 'polygon(0 0, 100% 100%, 0 100%)',
    },
    bottomTriangle: {
      height: '100%',
      width: '75%',
      shapeOutside: 'polygon(0 0, 0 10%, 90% 100%, 100% 100%, 100% 0)',
      display: 'flex',
      alignItems: 'flex-end',
      paddingBottom: 16,
      paddingLeft: 16,
      boxSizing: 'border-box',
    },
    labelContainer: {
      display: 'flex',
      alignItems: 'center',
    },
    label: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ...(theme.typography.lato.captionBold as any),
      color: '#372D41',
      paddingRight: 4,
      [theme.breakpoints.down('lg')]: {
        maxWidth: 'min-content',
      },
    },
    infoIcon: {
      color: '#0F689F',
    },
  })
)

const CornerTitlesCell = ({
  topTitle,
  bottomTitle,
  topTooltipText,
  bottomTooltipText,
  ...rest
}: CornerTitlesCellProps): ReactElement => {
  const classes = useStyles()
  return (
    <TableCell className={classes.root} {...rest}>
      <div className={classes.topTriangleWrapper}>
        <div className={classes.topTriangle}>
          <div className={classes.labelContainer}>
            <span className={classes.label}>{topTitle}</span>
            <Tooltip title={topTooltipText} placement="bottom-start">
              <InfoIcon fontSize="small" className={classes.infoIcon} />
            </Tooltip>
          </div>
        </div>
      </div>
      <div className={classes.bottomTriangleWrapper}>
        <div className={classes.bottomTriangle}>
          <div className={classes.labelContainer}>
            <span className={classes.label}>{bottomTitle}</span>
            <Tooltip title={bottomTooltipText} placement="bottom-start">
              <InfoIcon fontSize="small" className={classes.infoIcon} />
            </Tooltip>
          </div>
        </div>
      </div>
    </TableCell>
  )
}

export default CornerTitlesCell
